module.exports = __webpack_public_path__ + "static/img/banks.815a3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/banks.png
// module id = 1464
// module chunks = 2